import { createContext } from 'react';

export type AreaContextType = {
    activeVariantId: number;
    setActiveVariantId: (id: number) => void;
    draggedItemKey?: number;
    setDraggedItemKey: (id: number | undefined) => void;
};

export const AreaContext = createContext<AreaContextType | null>(null);
